module.exports = __webpack_public_path__ + "img/1440.2606a4c8.jpg";